/* Original concept architecture, using the existing Shopify section and app nodes. */
(function () {
  'use strict';
  function boot() {
    var main = document.querySelector('main.layout--template');
    var gallery = main && main.querySelector('.gg-gallery');
    var buybox = main && main.querySelector('.gg-buybox--top');
    var purchase = main && main.querySelector('.gg-buybox--bottom');
    var identity = buybox && buybox.querySelector('.gg-pdp-identity');
    if (!main || !gallery || !buybox || !purchase || !identity || main.querySelector('.gg-pdp-hero')) return;
    var gallerySection = gallery.closest('.shopify-section');
    var decisionSection = buybox.closest('.shopify-section');
    var purchaseSection = purchase.closest('.shopify-section');
    var sections = Array.from(main.children).filter(function (node) { return node.classList.contains('shopify-section'); });
    var decisionIndex = sections.indexOf(decisionSection);
    var purchaseIndex = sections.indexOf(purchaseSection);
    if (!gallerySection || !decisionSection || !purchaseSection || decisionIndex < 0) return;
    var plansSections = sections.slice(decisionIndex + 1, purchaseIndex);
    var hero = document.createElement('div');
    hero.className = 'gg-pdp-hero';
    main.insertBefore(hero, gallerySection);
    gallerySection.classList.add('gg-pdp-gallery-section');
    decisionSection.classList.add('gg-pdp-decision-section');
    purchaseSection.classList.add('gg-pdp-purchase-section');
    // Move, never clone: native form IDs, listeners, Loop and delivery state survive.
    hero.appendChild(identity);
    hero.appendChild(gallerySection);
    hero.appendChild(decisionSection);
    plansSections.forEach(function (section) { section.classList.add('gg-pdp-plans-section'); hero.appendChild(section); });
    hero.appendChild(purchaseSection);
    document.body.classList.add('gg-pdp-experience');
    document.dispatchEvent(new CustomEvent('gg:pdp-layout'));

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function goTo(target, focus) {
      if (!target) return;
      target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      if (focus) {
        var control = target.querySelector('[role="radio"][aria-checked="true"]') || target.querySelector('button,input,select');
        if (control) control.focus({ preventScroll: true });
      }
    }
    identity.querySelectorAll('[data-gg-choose-size]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var sizes = buybox.querySelector('.gg-buybox__size-section') || purchase;
        event.preventDefault(); goTo(sizes, true);
      });
    });
    var mobilePrice = identity.querySelector('[data-gg-mobile-price]');
    var mobileSize = identity.querySelector('[data-gg-mobile-size]');
    var configNode = document.querySelector('[data-gg-purchase-config]');
    var config = {};
    try { config = JSON.parse(configNode ? configNode.textContent : '{}'); } catch (error) { /* server-rendered price remains */ }
    function updateIdentity(event) {
      var state = event && event.detail;
      if (!state && window.GGPurchaseState) state = window.GGPurchaseState.getState();
      if (!state || !state.variant) return;
      if (String(state.productId) !== buybox.dataset.ggProductId) return;
      if (mobilePrice) {
        try { mobilePrice.textContent = new Intl.NumberFormat(config.locale || 'en-US', { style: 'currency', currency: config.currency || 'USD' }).format(state.unitPrice / 100); }
        catch (error) { mobilePrice.textContent = '$' + (state.unitPrice / 100).toFixed(2); }
      }
      if (mobileSize) mobileSize.textContent = state.variant.title === 'Default Title' ? '' : state.variant.title;
    }
    document.addEventListener('gg:purchase-change', updateIdentity);
    updateIdentity();

    // The compact proof entry uses only this PDP's real video posters and existing player.
    var proofLink = purchase.querySelector('[data-gg-proof-link]');
    var proof = document.getElementById('gg-grower-videos');
    var tiles = proof ? Array.from(proof.querySelectorAll('[data-gg-ugc-tile]')).filter(function (tile) { return tile.getAttribute('aria-hidden') !== 'true' && tile.dataset.video; }) : [];
    if (proofLink && tiles.length) {
      var faces = document.createElement('span');
      faces.className = 'gg-pdp-proof-faces'; faces.setAttribute('aria-hidden', 'true');
      tiles.slice(0, 3).forEach(function (tile) {
        var original = tile.querySelector('img');
        if (!original) return;
        var image = document.createElement('img');
        image.src = original.currentSrc || original.src; image.alt = ''; image.width = 31; image.height = 42; image.loading = 'lazy';
        faces.appendChild(image);
      });
      proofLink.prepend(faces); proofLink.hidden = false;
      proofLink.setAttribute('aria-haspopup', 'dialog');
      var videoModal = document.querySelector('[data-gg-ugc-lightbox]');
      var openedFromProof = false;
      if (videoModal) {
        new MutationObserver(function () {
          if (openedFromProof && videoModal.hidden) { openedFromProof = false; proofLink.focus({ preventScroll: true }); }
        }).observe(videoModal, { attributes: true, attributeFilter: ['hidden'] });
      }
      proofLink.addEventListener('click', function (event) {
        if (!videoModal) return;
        event.preventDefault(); openedFromProof = true; tiles[0].click();
      });
    }

    var routine = main.querySelector('.gg-bundle');
    if (routine && !routine.id) routine.id = 'gg-product-routine';
    var chapters = [
      ['gg-grower-videos', 'Grower videos'], ['gg-product-story', 'The product'],
      ['gg-product-formula', 'Ingredients'], ['gg-how-to-use', 'How to use'],
      ['judgeme_product_reviews', 'Reviews'], ['gg-product-routine', 'Your routine'],
      ['gg-product-faq', 'Questions']
    ].map(function (item) { return { id: item[0], label: item[1], element: document.getElementById(item[0]) }; }).filter(function (item) { return item.element; });
    chapters.sort(function (a, b) { return a.element.compareDocumentPosition(b.element) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });
    if (!chapters.length) return;
    var nav = document.createElement('nav');
    nav.className = 'gg-pdp-chapters'; nav.setAttribute('aria-label', 'Explore this product');
    var inner = document.createElement('div'); inner.className = 'gg-pdp-chapters__inner';
    chapters.forEach(function (chapter) {
      var link = document.createElement('a'); link.href = '#' + chapter.id; link.textContent = chapter.label;
      link.addEventListener('click', function (event) { event.preventDefault(); goTo(chapter.element, false); });
      chapter.link = link; inner.appendChild(link);
    });
    var progress = document.createElement('span'); progress.className = 'gg-pdp-chapters__progress'; progress.setAttribute('aria-hidden', 'true');
    nav.appendChild(inner); nav.appendChild(progress); hero.after(nav);
    var frame = 0, active = -1;
    function updateScroll() {
      frame = 0;
      // The concept header scrolls away. Only reserve height for an actually fixed header.
      var header = document.querySelector('.gg-site-header,.header--root,header[role="banner"]');
      var headerOffset = 0;
      if (header) {
        var position = window.getComputedStyle(header).position;
        var box = header.getBoundingClientRect();
        if ((position === 'fixed' || position === 'sticky') && box.top <= 1 && box.bottom > 0) headerOffset = box.bottom;
      }
      document.body.style.setProperty('--gg-pdp-header-offset', headerOffset + 'px');
      var threshold = headerOffset + nav.offsetHeight + 100;
      var nextActive = 0;
      chapters.forEach(function (chapter, index) { if (chapter.element.getBoundingClientRect().top <= threshold) nextActive = index; });
      if (nextActive !== active) {
        active = nextActive;
        chapters.forEach(function (chapter, index) {
          if (index === active) chapter.link.setAttribute('aria-current', 'location'); else chapter.link.removeAttribute('aria-current');
        });
        if (!nav.contains(document.activeElement)) {
          var current = chapters[active].link;
          inner.scrollTo({ left: Math.max(0, current.offsetLeft - inner.offsetLeft - inner.clientWidth / 2 + current.offsetWidth / 2), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
      }
      var first = chapters[0].element.getBoundingClientRect().top + window.scrollY;
      var last = chapters[chapters.length - 1].element.getBoundingClientRect();
      var distance = last.bottom + window.scrollY - first - window.innerHeight + threshold;
      var fraction = Math.max(0, Math.min(1, (window.scrollY + threshold - first) / Math.max(1, distance)));
      nav.style.setProperty('--gg-pdp-progress', fraction.toFixed(4));
    }
    function schedule() { if (!frame) frame = window.requestAnimationFrame(updateScroll); }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    updateScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
